import { gql } from '@apollo/client'

export const LEAD_CREATE = gql`
  mutation LibraryGuideLeadCreate($email: String!, $tag: String!) {
    leadCreate(email: $email, tag: $tag) {
      email
    }
  }
`
